export default __webpack_public_path__ + "static/media/Phone-Collections.a7911cbe.png";